const ResetPasswordPage = () => (
    <div className="reset-password-page">
        <h1>Reset Password Page</h1>
    </div>
)
 
export default ResetPasswordPage;